export default __webpack_public_path__ + "static/media/1864.0b5a536e.png";